// Print booklet (#1329): the `booklet` namespace — Ylläpito → Vihko, the cover
// image on Perustiedot and the download on Käsikirjoitus. In its own file so
// the strings grow here, not in fi.js / en.js / sv.js. `errors` keys are the
// backend's BookletError codes (apps/backend/src/services/booklet/).

export const bookletFi = {
  slots: { cover: 'Kansi', contents: 'Avausaukeama', filler: 'Täytesivu', back: 'Takakansi' },
  slotHelp: {
    cover: '1 sivu. Kuution nimi kirjoitetaan kanteen.',
    contents: '2 sivua. Sivulle 2 tulee Kuution tarkoitus ja kansikuva, sivun 3 yläkolmannekseen moduulilista.',
    filler: '1 sivu, esimerkiksi muistiinpanoille. Lisätään, jotta aukeamat osuvat kohdalleen ja sivumäärä on neljällä jaollinen.',
    back: '2 sivua: takakannen sisä- ja ulkopuoli.',
  },
  fields: { name: 'Kuution nimi', purpose: 'kuvaus eli tarkoitus', list: 'moduulilista' },
  admin: {
    title: 'Vihko',
    lead: 'Painovalmiin työpajavihkon sivut. Suunnittelija vie jokaisen sivun InDesignista PDF:ksi yhteisellä vientiasetuksella (PDF/X-4, 3 mm leikkuuvara, leikkuu- ja leikkuuvaramerkit). Jokainen Kuutio kokoaa vihkonsa näistä omalla kielellään Käsikirjoitus-sivulla.',
    sharedTitle: 'Yhteiset sivut',
    modulesTitle: 'Moduulien sivut',
    modulesLead: 'Moduulilla voi olla kuinka monta sivua tahansa; kahden tai useamman sivun moduuli alkaa vasemmalta sivulta. Moduuli, jolla ei ole PDF:ää, jää vihkosta ja sen moduulilistasta pois (esimerkiksi tauot).',
    search: 'Hae moduulia',
    outputCondition: 'Värinhallinta: {{condition}}',
    pages: '{{count}} s.',
    empty: 'Ei tiedostoa',
    upload: 'Lataa PDF',
    replace: 'Vaihda',
    open: 'Avaa',
    remove: 'Poista',
    removeConfirm: 'Poistetaanko {{slot}} ({{language}})? Vihkot kootaan sen jälkeen ilman tätä tiedostoa.',
    uploading: 'Ladataan… {{percent}} %',
    checking: 'Tarkistetaan…',
    saved: '{{slot}} ({{language}}) tallennettu.',
    loadFailed: 'Vihkon tiedostoja ei voitu hakea: {{error}}',
  },
  cover: {
    title: 'Vihkon kansikuva',
    lead: 'Kuva painovalmiin vihkon sivulle 2, Kuution tarkoituksen alle. Tarkoitus on Kuution kuvaus yllä. JPEG tai PNG, vähintään {{width}} × {{height}} px, jotta kuva painuu 300 dpi:n tarkkuudella.',
    none: 'Kansikuvaa ei ole vielä ladattu.',
    pick: 'Valitse kuva',
    replace: 'Vaihda kuva',
    remove: 'Poista kuva',
    removeConfirm: 'Poistetaanko vihkon kansikuva?',
    size: '{{width}} × {{height}} px',
    enough: 'Kuva riittää painoon.',
    lowRes: 'Kuva on liian pieni painoon: vähintään {{width}} × {{height}} px. Vihkoa ei voi koota ennen kuin kuva vaihdetaan.',
    uploading: 'Ladataan… {{percent}} %',
    alt: 'Vihkon kansikuva',
  },
  download: {
    button: 'Lataa vihko (PDF)',
    building: 'Kootaan vihkoa…',
    ready: 'Vihko valmis: {{pages}} sivua.',
    withoutPages: 'Ilman sivuja: {{modules}}.',
    failed: 'Vihkoa ei voitu koota: {{error}}',
  },
  errors: {
    missing_shared: 'Vihkon yhteinen sivu puuttuu: {{slot}} ({{language}}). Ylläpitäjä lisää sen Ylläpito → Vihko -sivulla.',
    missing_cover_image: 'Kansikuva puuttuu. Lisää se Perustiedot-sivulla.',
    missing_title: 'Kuutiolla ei ole nimeä.',
    missing_description: 'Kuutiolla ei ole kuvausta, joka on vihkon tarkoitusteksti. Lisää se Perustiedot-sivulla.',
    text_overflow: 'Teksti ei mahdu vihkoon: {{field}}. Lyhennä sitä.',
    image_resolution: 'Kansikuva painuisi vain {{dpi}} dpi:n tarkkuudella (vähintään {{minDpi}}). Vaihda isompi kuva Perustiedot-sivulla.',
    font_missing: 'Palvelimelta puuttuu vihkon fontti ({{file}}).',
    no_chain: 'Kuutiolla ei ole moduuliketjua.',
    wrong_page_count: '{{slot}}: väärä sivumäärä {{got}}, pitää olla {{expected}}.',
    no_trim_box: 'Sivulta {{page}} puuttuu rajaus (TrimBox). Vie PDF yhteisellä vientiasetuksella.',
    wrong_trim_size: 'Sivu {{page}} on {{width}} × {{height}} mm, ei A5.',
    no_bleed: 'Sivulta {{page}} puuttuu leikkuuvara. Vie PDF yhteisellä vientiasetuksella (3 mm leikkuuvara).',
    wrong_bleed: 'Sivun {{page}} leikkuuvara ei ole 3 mm joka reunalla.',
    no_marks: 'Sivulta {{page}} puuttuvat leikkuumerkit. Vie PDF yhteisellä vientiasetuksella.',
    no_output_intent: 'PDF ei ole PDF/X-muotoinen. Vie se yhteisellä vientiasetuksella (PDF/X-4).',
    output_condition_mismatch: 'PDF:n värinhallinta ({{got}}) poikkeaa vihkon muista tiedostoista ({{expected}}).',
    unreadable_pdf: 'Tiedostoa ei voi lukea PDF:nä.',
    encrypted_pdf: 'PDF on salasanasuojattu.',
    unsupported_image: 'Kansikuvan pitää olla JPEG tai PNG.',
    unreadable_image: 'Kuvaa ei voi lukea.',
    not_pdf: 'Tiedoston pitää olla PDF.',
    file_size: 'Tiedosto on liian suuri (enintään {{maxMb}} Mt).',
    upload_failed: 'Lataus epäonnistui. Yritä uudelleen.',
    other: 'Jokin meni vikaan: {{message}}',
  },
};

export const bookletEn = {
  slots: { cover: 'Cover', contents: 'Opening spread', filler: 'Filler page', back: 'Back cover' },
  slotHelp: {
    cover: '1 page. The Kuutio\'s name is written on the cover.',
    contents: '2 pages. Page 2 gets the Kuutio\'s purpose and cover image, the top third of page 3 the module list.',
    filler: '1 page, for example for notes. Added so that spreads face each other and the page count is a multiple of four.',
    back: '2 pages: the inside and outside of the back cover.',
  },
  fields: { name: 'the Kuutio\'s name', purpose: 'description (purpose)', list: 'module list' },
  admin: {
    title: 'Booklet',
    lead: 'The pages of the print-ready workshop booklet. The designer exports each page from InDesign to PDF with the shared export preset (PDF/X-4, 3 mm bleed, crop and bleed marks). Each Kuutio assembles its booklet from these in its own language on the Script page.',
    sharedTitle: 'Shared pages',
    modulesTitle: 'Module pages',
    modulesLead: 'A module can have any number of pages; one of two or more pages starts on a left-hand page. A module without a PDF is left out of the booklet and its module list (breaks, for example).',
    search: 'Search modules',
    outputCondition: 'Colour management: {{condition}}',
    pages: '{{count}} p.',
    empty: 'No file',
    upload: 'Upload PDF',
    replace: 'Replace',
    open: 'Open',
    remove: 'Remove',
    removeConfirm: 'Remove {{slot}} ({{language}})? Booklets are then assembled without this file.',
    uploading: 'Uploading… {{percent}} %',
    checking: 'Checking…',
    saved: '{{slot}} ({{language}}) saved.',
    loadFailed: 'Could not load the booklet files: {{error}}',
  },
  cover: {
    title: 'Booklet cover image',
    lead: 'The image on page 2 of the print-ready booklet, below the Kuutio\'s purpose. The purpose is the Kuutio\'s description above. JPEG or PNG, at least {{width}} × {{height}} px so it prints at 300 dpi.',
    none: 'No cover image uploaded yet.',
    pick: 'Choose image',
    replace: 'Replace image',
    remove: 'Remove image',
    removeConfirm: 'Remove the booklet cover image?',
    size: '{{width}} × {{height}} px',
    enough: 'The image is large enough to print.',
    lowRes: 'The image is too small to print: at least {{width}} × {{height}} px. The booklet can\'t be assembled until it is replaced.',
    uploading: 'Uploading… {{percent}} %',
    alt: 'Booklet cover image',
  },
  download: {
    button: 'Download booklet (PDF)',
    building: 'Assembling the booklet…',
    ready: 'Booklet ready: {{pages}} pages.',
    withoutPages: 'Without pages: {{modules}}.',
    failed: 'Could not assemble the booklet: {{error}}',
  },
  errors: {
    missing_shared: 'A shared booklet page is missing: {{slot}} ({{language}}). An admin adds it on Admin → Booklet.',
    missing_cover_image: 'The cover image is missing. Add it on the Basics page.',
    missing_title: 'The Kuutio has no name.',
    missing_description: 'The Kuutio has no description, which is the booklet\'s purpose text. Add it on the Basics page.',
    text_overflow: 'The text doesn\'t fit in the booklet: {{field}}. Shorten it.',
    image_resolution: 'The cover image would print at only {{dpi}} dpi (at least {{minDpi}}). Replace it with a larger image on the Basics page.',
    font_missing: 'The server is missing the booklet font ({{file}}).',
    no_chain: 'The Kuutio has no module chain.',
    wrong_page_count: '{{slot}}: wrong page count {{got}}, it must be {{expected}}.',
    no_trim_box: 'Page {{page}} has no TrimBox. Export the PDF with the shared preset.',
    wrong_trim_size: 'Page {{page}} is {{width}} × {{height}} mm, not A5.',
    no_bleed: 'Page {{page}} has no bleed. Export the PDF with the shared preset (3 mm bleed).',
    wrong_bleed: 'Page {{page}} does not have a 3 mm bleed on every side.',
    no_marks: 'Page {{page}} has no crop marks. Export the PDF with the shared preset.',
    no_output_intent: 'The PDF is not PDF/X. Export it with the shared preset (PDF/X-4).',
    output_condition_mismatch: 'The PDF\'s colour management ({{got}}) differs from the booklet\'s other files ({{expected}}).',
    unreadable_pdf: 'The file can\'t be read as a PDF.',
    encrypted_pdf: 'The PDF is password-protected.',
    unsupported_image: 'The cover image must be a JPEG or PNG.',
    unreadable_image: 'The image can\'t be read.',
    not_pdf: 'The file must be a PDF.',
    file_size: 'The file is too large (at most {{maxMb}} MB).',
    upload_failed: 'The upload failed. Try again.',
    other: 'Something went wrong: {{message}}',
  },
};

export const bookletSv = {
  slots: { cover: 'Pärm', contents: 'Öppningsuppslag', filler: 'Utfyllnadssida', back: 'Baksida' },
  slotHelp: {
    cover: '1 sida. Kuutions namn skrivs på pärmen.',
    contents: '2 sidor. Sida 2 får Kuutions syfte och omslagsbild, översta tredjedelen av sida 3 modullistan.',
    filler: '1 sida, till exempel för anteckningar. Läggs till så att uppslagen hamnar rätt och sidantalet är delbart med fyra.',
    back: '2 sidor: baksidans in- och utsida.',
  },
  fields: { name: 'Kuutions namn', purpose: 'beskrivning (syfte)', list: 'modullista' },
  admin: {
    title: 'Häfte',
    lead: 'Sidorna i det tryckfärdiga workshophäftet. Formgivaren exporterar varje sida från InDesign till PDF med den gemensamma exportinställningen (PDF/X-4, 3 mm utfall, skär- och utfallsmärken). Varje Kuutio sätter ihop sitt häfte av dessa på sitt eget språk på sidan Manus.',
    sharedTitle: 'Gemensamma sidor',
    modulesTitle: 'Modulernas sidor',
    modulesLead: 'En modul kan ha hur många sidor som helst; en modul på två eller fler sidor börjar på en vänstersida. En modul utan PDF lämnas bort ur häftet och dess modullista (till exempel pauser).',
    search: 'Sök modul',
    outputCondition: 'Färghantering: {{condition}}',
    pages: '{{count}} s.',
    empty: 'Ingen fil',
    upload: 'Ladda upp PDF',
    replace: 'Byt',
    open: 'Öppna',
    remove: 'Ta bort',
    removeConfirm: 'Ta bort {{slot}} ({{language}})? Häftena sätts sedan ihop utan den här filen.',
    uploading: 'Laddar upp… {{percent}} %',
    checking: 'Kontrollerar…',
    saved: '{{slot}} ({{language}}) sparad.',
    loadFailed: 'Häftets filer kunde inte hämtas: {{error}}',
  },
  cover: {
    title: 'Häftets omslagsbild',
    lead: 'Bilden på sida 2 i det tryckfärdiga häftet, under Kuutions syfte. Syftet är Kuutions beskrivning ovan. JPEG eller PNG, minst {{width}} × {{height}} px så att den trycks med 300 dpi.',
    none: 'Ingen omslagsbild har laddats upp ännu.',
    pick: 'Välj bild',
    replace: 'Byt bild',
    remove: 'Ta bort bild',
    removeConfirm: 'Ta bort häftets omslagsbild?',
    size: '{{width}} × {{height}} px',
    enough: 'Bilden räcker för tryck.',
    lowRes: 'Bilden är för liten för tryck: minst {{width}} × {{height}} px. Häftet kan inte sättas ihop förrän bilden byts.',
    uploading: 'Laddar upp… {{percent}} %',
    alt: 'Häftets omslagsbild',
  },
  download: {
    button: 'Ladda ner häftet (PDF)',
    building: 'Häftet sätts ihop…',
    ready: 'Häftet är klart: {{pages}} sidor.',
    withoutPages: 'Utan sidor: {{modules}}.',
    failed: 'Häftet kunde inte sättas ihop: {{error}}',
  },
  errors: {
    missing_shared: 'En gemensam sida saknas i häftet: {{slot}} ({{language}}). En administratör lägger till den på Administration → Häfte.',
    missing_cover_image: 'Omslagsbilden saknas. Lägg till den på sidan Grunduppgifter.',
    missing_title: 'Kuution har inget namn.',
    missing_description: 'Kuution har ingen beskrivning, som är häftets syftestext. Lägg till den på sidan Grunduppgifter.',
    text_overflow: 'Texten ryms inte i häftet: {{field}}. Korta ner den.',
    image_resolution: 'Omslagsbilden skulle tryckas med bara {{dpi}} dpi (minst {{minDpi}}). Byt till en större bild på sidan Grunduppgifter.',
    font_missing: 'Servern saknar häftets typsnitt ({{file}}).',
    no_chain: 'Kuution har ingen modulkedja.',
    wrong_page_count: '{{slot}}: fel sidantal {{got}}, ska vara {{expected}}.',
    no_trim_box: 'Sida {{page}} saknar TrimBox. Exportera PDF:en med den gemensamma inställningen.',
    wrong_trim_size: 'Sida {{page}} är {{width}} × {{height}} mm, inte A5.',
    no_bleed: 'Sida {{page}} saknar utfall. Exportera PDF:en med den gemensamma inställningen (3 mm utfall).',
    wrong_bleed: 'Sida {{page}} har inte 3 mm utfall på varje kant.',
    no_marks: 'Sida {{page}} saknar skärmärken. Exportera PDF:en med den gemensamma inställningen.',
    no_output_intent: 'PDF:en är inte PDF/X. Exportera den med den gemensamma inställningen (PDF/X-4).',
    output_condition_mismatch: 'PDF:ens färghantering ({{got}}) skiljer sig från häftets övriga filer ({{expected}}).',
    unreadable_pdf: 'Filen kan inte läsas som PDF.',
    encrypted_pdf: 'PDF:en är lösenordsskyddad.',
    unsupported_image: 'Omslagsbilden ska vara JPEG eller PNG.',
    unreadable_image: 'Bilden kan inte läsas.',
    not_pdf: 'Filen ska vara en PDF.',
    file_size: 'Filen är för stor (högst {{maxMb}} MB).',
    upload_failed: 'Uppladdningen misslyckades. Försök igen.',
    other: 'Något gick fel: {{message}}',
  },
};
